// ThreeStepsSection.js
import React from 'react';

const ThreeStepsSection = () => {
  const steps = [
    {
      number: '1',
      title: 'CALL OUR OFFICE AT',
      subtitle: '+61 480 804 640',
      description: 'Friendly staff members are waiting to take your call and answer your questions.'
    },
    {
      number: '2',
      title: 'SCHEDULE FREE',
      subtitle: 'IN-HOME ASSESSMENT',
      description: 'This will help us design your customised care plan with your specific needs in mind.'
    },
    {
      number: '3',
      title: 'ENJOY COMFORT &',
      subtitle: 'FREEDOM AT HOME',
      description: 'Enjoy the companionship of a certified carer & thrive in the comfort of home.'
    }
  ];

  return (
    <section className="bg-bnCream py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <p className="text-bnAccent text-xs md:text-sm font-medium tracking-[0.22em] uppercase mb-5">
            Getting Started
          </p>
          <h2 className="font-display font-light text-bnInk leading-[1.1] text-3xl md:text-4xl lg:text-5xl">
            Three Steps to Senior Independence and Peace of Mind for You
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              {/* Circle with Number */}
              <div className="relative w-24 h-24 mb-6">
                {/* Accent arc on right side */}
                <svg className="absolute inset-0 w-24 h-24 -rotate-90">
                  <circle
                    cx="48"
                    cy="48"
                    r="44"
                    className="stroke-bnAccent"
                    strokeWidth="6"
                    fill="none"
                    strokeDasharray="138 276"
                    strokeLinecap="round"
                  />
                </svg>
                {/* Soft border ring on left side */}
                <svg className="absolute inset-0 w-24 h-24 rotate-90">
                  <circle
                    cx="48"
                    cy="48"
                    r="44"
                    className="stroke-bnBorder"
                    strokeWidth="6"
                    fill="none"
                    strokeDasharray="138 276"
                    strokeLinecap="round"
                  />
                </svg>
                {/* Number in center */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="font-display font-light text-4xl text-bnInk">{step.number}</span>
                </div>
              </div>

              {/* Content */}
              <div className="space-y-1">
                <h3 className="text-bnInk font-medium text-lg tracking-wide">
                  {step.title}
                </h3>
                <h4 className="text-bnAccent font-medium text-lg tracking-wide">
                  {step.subtitle}
                </h4>
                <p className="text-bnBody text-sm leading-relaxed max-w-xs mx-auto pt-2">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ThreeStepsSection;
